// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staking-risk_staking-risk-details-wrapper__uJ5qB {
    width: 100%;
    display: flex;
    gap: 20px;
}

.staking-risk_staking-risk-details-left__ZWZII {
    width: 350px;
    background: #f0f0f3;
    border-radius: 24px;
    box-shadow: 8px 8px 24px 0px #aeaec066;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    height: 90vh;
    overflow: auto;
    gap: 10px;
}

.staking-risk_staking-risk-details-left-item__SIaT4 {
    display: flex;
    justify-content: space-around;
    width: 325px;
    /* height: 120px; */
    /* width: 100%; */
    /* margin-bottom: 10px; */
    /* margin-top: 40px;
    padding: 10px 5px 0px 25px; */
    padding: 10px 5px 0px 25px;
    position: relative;
    /* top: 25.7%; */
}

.staking-risk_staking-risk-details-left-item__SIaT4:hover {
    background-color: #fdfdfd;
    position: relative;
    padding: 10px 5px 0px 25px;
    /* height: 120px; */
}

.staking-risk_staking-risk-details-left-item-content__-JVZQ {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
}

.staking-risk_staking-risk-details-left-item-title__TasZd {
    font-family: Assistant;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: #364048;
    width: 80px;
}

.staking-risk_staking-risk-details-left-item-total__vv\\+vr {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    color: #889096;
}

.staking-risk_staking-risk-details-left-item-percent__bMKSs {
    font-family: Assistant;
    font-weight: 700;
    font-size: 16px;
}

.staking-risk_staking-risk-details-left-item-total-percent__DlX29 {
    color: #364049;
}

.staking-risk_divider__5yVAC {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 50%, rgba(255, 255, 255, 0) 100%);
    width: 312px;
    height: 2px;
    margin: 10px auto;
    position: static;
}
.staking-risk_staking-risk-details-left-item__SIaT4.staking-risk_active__4oJ3z + .staking-risk_divider__5yVAC {
    display: none;
}

.staking-risk_staking-risk-details-left-item__SIaT4.staking-risk_active__4oJ3z {
    background-color: #fdfdfd;
    position: fixed;
    /* height: 117px; */
    width: 18.2%;
    left: 90px;
    top: 135px;
    z-index: 8;
}
.staking-risk_staking-risk-details-left-item__SIaT4.staking-risk_active__4oJ3z::after {
    content: "";
    position: absolute;
    bottom: -10px;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 50%, rgba(255, 255, 255, 0) 100%);
}
.staking-risk_staking-risk-details-left-item__SIaT4.staking-risk_active-zoom__KRKqa {
    background-color: #fdfdfd;
    position: fixed;
    /* height: 117px; */
    width: 18.8%;
    left: 120px;
    top: 21%;
    z-index: 8;
}

.staking-risk_staking-risk-content__jJ1rj {
    margin-top: 180px;
    overflow-y: auto;
}
.staking-risk_staking-risk-details-left-item__SIaT4.staking-risk_active__4oJ3z + .staking-risk_divider__5yVAC {
    /* position: fixed;*/
    /* top: 9%; */
    /* height: 117px; */
}

/* .staking-risk-details-left-item.active::after {
    content: "";
    position: absolute;
    right: -21px;
    top: 0;
    height: 100%;
    width: 40px;
    background-color: #fff;
} */

.staking-risk_staking-risk-details-inner__O17i1 {
    /* width: 17.8%; */
    left: 88px;
    overflow: visible;
    background-color: #f0f0f3;
    /* height: 78px; */
    border-radius: 24px 24px 0 0;
    /* position: fixed; */
    z-index: 100;
}

.staking-risk_staking-risk-details-right__58pSu {
    width: 1120px;
    height: 90vh;
    overflow: auto;
    background: #fdfdfd;
    border-radius: 16px;
    box-shadow: 8px 8px 24px 0px #aeaec066;
    padding-bottom: 85px;
}

/*RIGHT CONTENT*/
.staking-risk_sr-right-header__SGI8Q {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    height: 96px;
    padding: 10px 15px;
    background: #fdfdfd;
    width: 56%;
    border-radius: 16px;

    /*1120px;*/
    z-index: 2;
}

.staking-risk_sr-right-header-left__xR6V6 {
    display: flex;
    gap: 10px;
    align-items: center;
}

.staking-risk_arrow__zRDyr {
    width: 40px;
    height: 40px;
    padding: 10px 12px;
    border-radius: 40px;
    border: 1px solid #f0f0f3;
    cursor: pointer;
    box-sizing: border-box;
    box-shadow: -1px 1px 8px 1px #88909666;
}

.staking-risk_arrow__zRDyr:hover {
    background-color: #8890961a;
    border-color: #3640481a;
}

.staking-risk_title__kHfXI {
    font-family: Assistant;
    font-weight: 600;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #364048;
}

.staking-risk_title__kHfXI span {
    font-family: Assistant;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 24px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #889096;
}

.staking-risk_sr-right-header-right__S02Lg {
    display: flex;
    align-items: baseline;
    gap: 20px;
}

.staking-risk_alert__niRg\\+ {
    width: 64px;
    height: 64px;
    border-radius: 360px;
    box-shadow: -3px -3px 9px 0px #ffffff;
    box-shadow: 3px 3px 9px 0px #aeaec066;
}

/*Colored Statistics*/
.staking-risk_statistic-wrapper__uOHzX {
    padding: 6rem 1rem 1rem 1rem;
    background: #fdfdfd;
    border-radius: 30px;
    width: 100%;
}

.staking-risk_statistic-content__TlTSB {
    display: flex;
    flex-direction: row;
    gap: 5px;
    margin-top: 1rem;
}

.staking-risk_statistic-item__77nSs {
    display: flex;
    flex-direction: column;
    height: 70px;
    position: relative;
}

.staking-risk_statistic-item__77nSs p {
    font-family: Assistant;
    font-weight: 400;
    font-size: 16px;
    color: #364048;
    white-space: nowrap;
}

.staking-risk_bar__MvdjT {
    height: 40px;
    border-radius: 30px;
    transition: width 0.5s ease;
    margin-top: 10px;
    padding-right: 10px;
}

.staking-risk_bar__MvdjT::after {
    content: "";
    position: absolute;
    right: -3px;
    top: 40%;
    margin-top: 6px;
    width: 1px;
    height: 50%;
    background-color: #889096;
}

/* Remove ::after for last bar */
.staking-risk_noAfter__3i5jk::after {
    display: none;
}

.staking-risk_bar__MvdjT span {
    background: #0000004d;
    padding: 4px 20px;
    display: flex;
    justify-content: flex-end;
    border-radius: 50px;
    width: 80px;
    color: #fff;
    height: 30px;
}

.staking-risk_statistic-wrapper__uOHzX h1 {
    font-family: Assistant;
    font-weight: 600;
    font-size: 24px;
    color: #889096;
}

/*Product Card*/
.staking-risk_card-wrapper__VLQaG {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem 3rem;
    /* adjust spacing between cards */
    padding: 1rem 1rem;
}

.staking-risk_card__IKSF\\+ {
    background: #f0f0f380;
    border: 1px solid #eee;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    height: 480px;
    width: 315px;
    overflow-x: auto;
}

.staking-risk_card__IKSF\\+:hover {
    background: #8890961a;
}

.staking-risk_card__IKSF\\+:hover .staking-risk_arrow__zRDyr {
    background-color: #fff;
}

.staking-risk_card-header__R9RNo {
    display: flex;
    justify-content: space-between;
    padding: 0px 10px;
    align-items: center;
    cursor: pointer;
}

.staking-risk_level__yOKzs {
    font-family: Assistant;
    font-weight: 600;
    font-size: 18px;
    color: #4dc7b5;
}

.staking-risk_line__jT85X {
    width: 100%;
    height: 2px;
    background-color: #3640481a;
    margin: 8px 0;
}

.staking-risk_w-score__xWdi0 {
    font-family: Assistant;
    font-weight: 600;
    font-size: 16px;
    color: #2267a4;
}

.staking-risk_w-scorevalue__TxqAR {
    font-family: Assistant;
    font-weight: 600;
    font-size: 16px;
    color: #364048;
    text-align: right;
}

.staking-risk_level__yOKzs {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    color: #4dc7b5;
    text-align: right;
}

.staking-risk_card-content__-k4S5 {
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
}

.staking-risk_card-content-wrapper__xk45o .staking-risk_card-content__-k4S5:nth-child(even) {
    background-color: #fff;
}

.staking-risk_card-content-wrapper__xk45o .staking-risk_card-content__-k4S5:nth-child(odd) {
    background-color: #8484840d;
}

.staking-risk_card__IKSF\\+:hover .staking-risk_card-content-wrapper__xk45o .staking-risk_card-content__-k4S5:nth-child(even) {
    background-color: #8484840d;
}

.staking-risk_card__IKSF\\+:hover .staking-risk_card-content-wrapper__xk45o .staking-risk_card-content__-k4S5:nth-child(odd) {
    background-color: #8890961a;
}

.staking-risk_asset__-QsOQ {
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    color: #364048;
}

/*Single*/
.staking-risk_product-details__ddj3l {
    margin: 15px;
    position: relative;
    top: 10%;
}

.staking-risk_product-details-items__dG\\+Wr {
    position: relative;
    top: 10%;
    background: #f0f0f380;
    min-height: 220px;
    border-radius: 24px;
    padding: 20px 30px;
    margin-bottom: 20px;
    overflow: visible;
}

.staking-risk_product-details-items-title__FkXYC {
    font-family: Assistant;
    font-weight: 600;
    font-size: 18px;
    color: #364048;
}

.staking-risk_product-details-items-level__rOrtG {
    font-family: Assistant;
    font-weight: 600;
    font-size: 16px;
    line-height: 35px;
}

.staking-risk_product-details-items-description__3eRcb {
    max-height: 55vh;
    /* adjust */
    overflow-y: auto;
    white-space: pre-line;
    font-family: Assistant;
    font-weight: 600;
    font-size: 14px;
    color: #364048;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Main/StakingRiskDetails/staking-risk.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB;iCAC6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uGAAuG;IACvG,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uGAAuG;AAC3G;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;;IAEnB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA,qBAAqB;AACrB;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".staking-risk-details-wrapper {\n    width: 100%;\n    display: flex;\n    gap: 20px;\n}\n\n.staking-risk-details-left {\n    width: 350px;\n    background: #f0f0f3;\n    border-radius: 24px;\n    box-shadow: 8px 8px 24px 0px #aeaec066;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: column;\n    align-items: center;\n    height: 90vh;\n    overflow: auto;\n    gap: 10px;\n}\n\n.staking-risk-details-left-item {\n    display: flex;\n    justify-content: space-around;\n    width: 325px;\n    /* height: 120px; */\n    /* width: 100%; */\n    /* margin-bottom: 10px; */\n    /* margin-top: 40px;\n    padding: 10px 5px 0px 25px; */\n    padding: 10px 5px 0px 25px;\n    position: relative;\n    /* top: 25.7%; */\n}\n\n.staking-risk-details-left-item:hover {\n    background-color: #fdfdfd;\n    position: relative;\n    padding: 10px 5px 0px 25px;\n    /* height: 120px; */\n}\n\n.staking-risk-details-left-item-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 8px;\n}\n\n.staking-risk-details-left-item-title {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 25px;\n    color: #364048;\n    width: 80px;\n}\n\n.staking-risk-details-left-item-total {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    color: #889096;\n}\n\n.staking-risk-details-left-item-percent {\n    font-family: Assistant;\n    font-weight: 700;\n    font-size: 16px;\n}\n\n.staking-risk-details-left-item-total-percent {\n    color: #364049;\n}\n\n.divider {\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 50%, rgba(255, 255, 255, 0) 100%);\n    width: 312px;\n    height: 2px;\n    margin: 10px auto;\n    position: static;\n}\n.staking-risk-details-left-item.active + .divider {\n    display: none;\n}\n\n.staking-risk-details-left-item.active {\n    background-color: #fdfdfd;\n    position: fixed;\n    /* height: 117px; */\n    width: 18.2%;\n    left: 90px;\n    top: 135px;\n    z-index: 8;\n}\n.staking-risk-details-left-item.active::after {\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    width: 100%;\n    height: 2px;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 50%, rgba(255, 255, 255, 0) 100%);\n}\n.staking-risk-details-left-item.active-zoom {\n    background-color: #fdfdfd;\n    position: fixed;\n    /* height: 117px; */\n    width: 18.8%;\n    left: 120px;\n    top: 21%;\n    z-index: 8;\n}\n\n.staking-risk-content {\n    margin-top: 180px;\n    overflow-y: auto;\n}\n.staking-risk-details-left-item.active + .divider {\n    /* position: fixed;*/\n    /* top: 9%; */\n    /* height: 117px; */\n}\n\n/* .staking-risk-details-left-item.active::after {\n    content: \"\";\n    position: absolute;\n    right: -21px;\n    top: 0;\n    height: 100%;\n    width: 40px;\n    background-color: #fff;\n} */\n\n.staking-risk-details-inner {\n    /* width: 17.8%; */\n    left: 88px;\n    overflow: visible;\n    background-color: #f0f0f3;\n    /* height: 78px; */\n    border-radius: 24px 24px 0 0;\n    /* position: fixed; */\n    z-index: 100;\n}\n\n.staking-risk-details-right {\n    width: 1120px;\n    height: 90vh;\n    overflow: auto;\n    background: #fdfdfd;\n    border-radius: 16px;\n    box-shadow: 8px 8px 24px 0px #aeaec066;\n    padding-bottom: 85px;\n}\n\n/*RIGHT CONTENT*/\n.sr-right-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: fixed;\n    height: 96px;\n    padding: 10px 15px;\n    background: #fdfdfd;\n    width: 56%;\n    border-radius: 16px;\n\n    /*1120px;*/\n    z-index: 2;\n}\n\n.sr-right-header-left {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.arrow {\n    width: 40px;\n    height: 40px;\n    padding: 10px 12px;\n    border-radius: 40px;\n    border: 1px solid #f0f0f3;\n    cursor: pointer;\n    box-sizing: border-box;\n    box-shadow: -1px 1px 8px 1px #88909666;\n}\n\n.arrow:hover {\n    background-color: #8890961a;\n    border-color: #3640481a;\n}\n\n.title {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    color: #364048;\n}\n\n.title span {\n    font-family: Assistant;\n    font-weight: 600;\n    font-style: SemiBold;\n    font-size: 24px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    color: #889096;\n}\n\n.sr-right-header-right {\n    display: flex;\n    align-items: baseline;\n    gap: 20px;\n}\n\n.alert {\n    width: 64px;\n    height: 64px;\n    border-radius: 360px;\n    box-shadow: -3px -3px 9px 0px #ffffff;\n    box-shadow: 3px 3px 9px 0px #aeaec066;\n}\n\n/*Colored Statistics*/\n.statistic-wrapper {\n    padding: 6rem 1rem 1rem 1rem;\n    background: #fdfdfd;\n    border-radius: 30px;\n    width: 100%;\n}\n\n.statistic-content {\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n    margin-top: 1rem;\n}\n\n.statistic-item {\n    display: flex;\n    flex-direction: column;\n    height: 70px;\n    position: relative;\n}\n\n.statistic-item p {\n    font-family: Assistant;\n    font-weight: 400;\n    font-size: 16px;\n    color: #364048;\n    white-space: nowrap;\n}\n\n.bar {\n    height: 40px;\n    border-radius: 30px;\n    transition: width 0.5s ease;\n    margin-top: 10px;\n    padding-right: 10px;\n}\n\n.bar::after {\n    content: \"\";\n    position: absolute;\n    right: -3px;\n    top: 40%;\n    margin-top: 6px;\n    width: 1px;\n    height: 50%;\n    background-color: #889096;\n}\n\n/* Remove ::after for last bar */\n.noAfter::after {\n    display: none;\n}\n\n.bar span {\n    background: #0000004d;\n    padding: 4px 20px;\n    display: flex;\n    justify-content: flex-end;\n    border-radius: 50px;\n    width: 80px;\n    color: #fff;\n    height: 30px;\n}\n\n.statistic-wrapper h1 {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 24px;\n    color: #889096;\n}\n\n/*Product Card*/\n.card-wrapper {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem 3rem;\n    /* adjust spacing between cards */\n    padding: 1rem 1rem;\n}\n\n.card {\n    background: #f0f0f380;\n    border: 1px solid #eee;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n    height: 480px;\n    width: 315px;\n    overflow-x: auto;\n}\n\n.card:hover {\n    background: #8890961a;\n}\n\n.card:hover .arrow {\n    background-color: #fff;\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    padding: 0px 10px;\n    align-items: center;\n    cursor: pointer;\n}\n\n.level {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 18px;\n    color: #4dc7b5;\n}\n\n.line {\n    width: 100%;\n    height: 2px;\n    background-color: #3640481a;\n    margin: 8px 0;\n}\n\n.w-score {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 16px;\n    color: #2267a4;\n}\n\n.w-scorevalue {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 16px;\n    color: #364048;\n    text-align: right;\n}\n\n.level {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    color: #4dc7b5;\n    text-align: right;\n}\n\n.card-content {\n    display: flex;\n    justify-content: space-between;\n    padding: 8px 15px;\n}\n\n.card-content-wrapper .card-content:nth-child(even) {\n    background-color: #fff;\n}\n\n.card-content-wrapper .card-content:nth-child(odd) {\n    background-color: #8484840d;\n}\n\n.card:hover .card-content-wrapper .card-content:nth-child(even) {\n    background-color: #8484840d;\n}\n\n.card:hover .card-content-wrapper .card-content:nth-child(odd) {\n    background-color: #8890961a;\n}\n\n.asset {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    color: #364048;\n}\n\n/*Single*/\n.product-details {\n    margin: 15px;\n    position: relative;\n    top: 10%;\n}\n\n.product-details-items {\n    position: relative;\n    top: 10%;\n    background: #f0f0f380;\n    min-height: 220px;\n    border-radius: 24px;\n    padding: 20px 30px;\n    margin-bottom: 20px;\n    overflow: visible;\n}\n\n.product-details-items-title {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 18px;\n    color: #364048;\n}\n\n.product-details-items-level {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 35px;\n}\n\n.product-details-items-description {\n    max-height: 55vh;\n    /* adjust */\n    overflow-y: auto;\n    white-space: pre-line;\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 14px;\n    color: #364048;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"staking-risk-details-wrapper": `staking-risk_staking-risk-details-wrapper__uJ5qB`,
	"staking-risk-details-left": `staking-risk_staking-risk-details-left__ZWZII`,
	"staking-risk-details-left-item": `staking-risk_staking-risk-details-left-item__SIaT4`,
	"staking-risk-details-left-item-content": `staking-risk_staking-risk-details-left-item-content__-JVZQ`,
	"staking-risk-details-left-item-title": `staking-risk_staking-risk-details-left-item-title__TasZd`,
	"staking-risk-details-left-item-total": `staking-risk_staking-risk-details-left-item-total__vv+vr`,
	"staking-risk-details-left-item-percent": `staking-risk_staking-risk-details-left-item-percent__bMKSs`,
	"staking-risk-details-left-item-total-percent": `staking-risk_staking-risk-details-left-item-total-percent__DlX29`,
	"divider": `staking-risk_divider__5yVAC`,
	"active": `staking-risk_active__4oJ3z`,
	"active-zoom": `staking-risk_active-zoom__KRKqa`,
	"staking-risk-content": `staking-risk_staking-risk-content__jJ1rj`,
	"staking-risk-details-inner": `staking-risk_staking-risk-details-inner__O17i1`,
	"staking-risk-details-right": `staking-risk_staking-risk-details-right__58pSu`,
	"sr-right-header": `staking-risk_sr-right-header__SGI8Q`,
	"sr-right-header-left": `staking-risk_sr-right-header-left__xR6V6`,
	"arrow": `staking-risk_arrow__zRDyr`,
	"title": `staking-risk_title__kHfXI`,
	"sr-right-header-right": `staking-risk_sr-right-header-right__S02Lg`,
	"alert": `staking-risk_alert__niRg+`,
	"statistic-wrapper": `staking-risk_statistic-wrapper__uOHzX`,
	"statistic-content": `staking-risk_statistic-content__TlTSB`,
	"statistic-item": `staking-risk_statistic-item__77nSs`,
	"bar": `staking-risk_bar__MvdjT`,
	"noAfter": `staking-risk_noAfter__3i5jk`,
	"card-wrapper": `staking-risk_card-wrapper__VLQaG`,
	"card": `staking-risk_card__IKSF+`,
	"card-header": `staking-risk_card-header__R9RNo`,
	"level": `staking-risk_level__yOKzs`,
	"line": `staking-risk_line__jT85X`,
	"w-score": `staking-risk_w-score__xWdi0`,
	"w-scorevalue": `staking-risk_w-scorevalue__TxqAR`,
	"card-content": `staking-risk_card-content__-k4S5`,
	"card-content-wrapper": `staking-risk_card-content-wrapper__xk45o`,
	"asset": `staking-risk_asset__-QsOQ`,
	"product-details": `staking-risk_product-details__ddj3l`,
	"product-details-items": `staking-risk_product-details-items__dG+Wr`,
	"product-details-items-title": `staking-risk_product-details-items-title__FkXYC`,
	"product-details-items-level": `staking-risk_product-details-items-level__rOrtG`,
	"product-details-items-description": `staking-risk_product-details-items-description__3eRcb`
};
export default ___CSS_LOADER_EXPORT___;
